import React from 'react'

// Pictogram tile above a modal title (Figma "Fenêtre", node 350:13546): 48px tile with 12px
// corners, 24px icon. `danger` is the red alert of a destructive action (cancel, interrupt),
// `warning` the orange one of leaving a form without saving.
const TONES = {
    danger: {background: '#FEF2F2', color: '#EF4444'},
    // Leaving a form without saving: the same alert, in the brand orange (yellow-50 / yellow-500).
    warning: {background: '#FFF6EB', color: '#FF9600'},
}

const AlertTriangle = ({color}) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
            d="M21.73 18L13.73 4C13.556 3.692 13.303 3.436 12.997 3.258C12.691 3.08 12.344 2.986 11.99 2.986C11.636 2.986 11.289 3.08 10.983 3.258C10.677 3.436 10.424 3.692 10.25 4L2.25 18C2.074 18.305 1.981 18.652 1.982 19.005C1.983 19.357 2.077 19.703 2.254 20.008C2.432 20.312 2.687 20.565 2.994 20.739C3.3 20.913 3.647 21.003 4 21H20C20.351 21 20.696 20.907 20.999 20.731C21.303 20.556 21.555 20.303 21.73 19.999C21.906 19.695 21.998 19.35 21.998 19C21.998 18.649 21.905 18.304 21.73 18Z"
            stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        />
        <path d="M12 9V13" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 17H12.01" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

const ICONS = {
    danger: AlertTriangle,
    warning: AlertTriangle,
}

const ModalIconTile = ({tone = 'danger'}) => {
    const {background, color} = TONES[tone] ?? TONES.danger
    const Icon = ICONS[tone] ?? AlertTriangle

    return (
        <div className="corner-smooth-12 flex h-12 w-12 items-center justify-center" style={{backgroundColor: background}}>
            <Icon color={color}/>
        </div>
    )
}

export default ModalIconTile
